import React, { useEffect } from 'react';
import I18n from 'i18n-js';
import { TextAreaField, TextField, CheckboxField } from 'common/Forms';
import useFlags from '../../../hooks/useFlags';
import { useUserInfo } from '../../../hooks/useUserInfo';
import GradeBySection from './GradeBySection';
import Section from './Section';
import sectionStyles from './Section.module.scss';
import useAssignablesStore from './WhatSection/store/useAssignablesStore';

const NotesSection = () => {
  const initialValues = useAssignablesStore(state => state.initialValues);
  const formChangeValue = useAssignablesStore(state => state.formChangeValue);
  const loadingLessons = useAssignablesStore(state => state.loadingLessons);
  const loadingTypes = useAssignablesStore(state => state.loadingTypes);
  const selectedType = useAssignablesStore(state => state.selectedType);
  const { usesAssignmentsBasedGrading } = useFlags();
  const showGradeBySection = !usesAssignmentsBasedGrading && selectedType === 'sectionNotebook';
  const userInfo = useUserInfo();
  const studentViewAssessmentResultsOff = userInfo?.staffer?.settings?.student_view_assessment_results_off;

  useEffect(() => {
    if (loadingLessons || loadingTypes) return;
    if (!initialValues || !selectedType) return;

    formChangeValue(initialValues.randomizeAnswers, 'randomize_answers');
    formChangeValue(initialValues.showAnswersToStudents, 'show_answers_to_students');
  }, [loadingTypes, loadingLessons, initialValues, selectedType]);

  return (
    <Section title="Optional">
      {selectedType === 'assessment' && (
        <div className={sectionStyles.row}>
          <label className="bold" htmlFor="randomize_answers_field">Assignment Settings:</label>
          <CheckboxField
            label="Randomize answer choices"
            labelPos="right"
            name="randomize_answers"
            rowClass={sectionStyles.checkboxField}
            tooltipText={I18n.t('randomize_answer_choices_message')}
          />

          {!studentViewAssessmentResultsOff && (
            <CheckboxField
              label={I18n.t('show_answers_to_students')}
              labelPos="right"
              name="show_answers_to_students"
              rowClass={sectionStyles.checkboxField}
              tooltipText={I18n.t('show_answers_to_students_tooltip')}
            />
          )}
        </div>
      )}

      {showGradeBySection && <GradeBySection />}

      <div className={sectionStyles.row}>
        <label className="bold" htmlFor="name_field">Assignment Name:</label>
        <TextField
          hideLabel
          name="name"
          placeholder="Start typing here..."
        />
      </div>
      <div className={sectionStyles.row}>
        <label className="bold" htmlFor="notes_field">Assignment Directions:</label>
        <TextAreaField
          hideLabel
          className={sectionStyles.textArea}
          name="notes"
          placeholder="Start typing here..."
        />
      </div>
    </Section>
  );
};

export default NotesSection;
